import React from "react";
import Logo from "../../../../assets/images/logo.svg";
import ArrowUp from "../../../../assets/images/icons/arrow-up.svg";

export const FooterLeft: React.FC = () => {
  return (
    <section className="flex flex-col justify-between h-full w-full lg:pb-[10%]">
      <div className="text-left mb-10 invert">
        <img src={Logo} alt="Logo" className="w-[45%] brightness-1 invert" />
      </div>
      <div className="h-0 lg:h-[60px]"></div>

      <div className="mt-auto lg:absolute lg:bottom-[2%]">
        <button
          aria-label="Scroll to top"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="w-[80px] h-[80px] lg:w-[130px] lg:h-[130px] flex items-center justify-center rounded-full border border-gray-200 bg-gray-50 hover:bg-gray-100 transition-colors"
        >
          <img
            src={ArrowUp}
            alt="Arrow Up"
            className="w-[30px] h-[30px] lg:w-[50px] lg:h-[50px]"
          />
        </button>
      </div>
    </section>
  );
};
